<template>
  <v-select
    multiple
    :loading="loading"
    :options="projectOptions"
    :reduce="option => option.value"
    :value="value"
    @input="setValue"
    :placeholder="$t('selects.projectsSelectPlaceholder')"
  />
</template>

<script>
import projectsApi from '@/api/projects'
import { mapSettings } from '@/utils/settings'

export default {
  props: {
    value: { type: Array },
    companyUuid: { type: String },
  },
  data: () => ({
    projects: null,
    loading: true,
  }),
  computed: {
    ...mapSettings(['projectUuids']),
    projectOptions() {
      return this.projects?.map(project => ({
        value: project.uuid,
        label: project.name,
      }))
    },
  },
  methods: {
    setValue(value) {
      this.projectUuids = value
      this.$emit('input', value)
    },
  },
  watch: {
    companyUuid: {
      async handler() {
        if (!this.companyUuid) return

        this.loading = true
        this.projects = await projectsApi.getAll(this.companyUuid)
        this.loading = false

        const initialSelectedProjectUuids = this.projects
          .map(project => project.uuid)
          .filter(uuid => this.projectUuids.includes(uuid))

        this.setValue(initialSelectedProjectUuids)
      },
      immediate: true,
    },
  },
}
</script>
